import {UserRole} from "../models/fixture/userRole";
import {OpenLevel} from "../models/fixture/openLevel";
import {TeamInfo, UserInfo} from "../models/utilTypes";
import {IUserRepository, UserRepository} from "../infrastructure/reposirory/userRepository";

export interface IUserService {
  info(): Promise<UserInfo>;
  update(name: string, email: string): Promise<void>;
  delete(): Promise<void>;
  joinNewTeam(teamName: string, teamPassword:string, teamRegion:number, myTeamId:string): Promise<TeamInfo>;
  createTeam(teamName:string, teamPassword:string, regionNum:number, myTeamId:string, openLevel:OpenLevel): Promise<TeamInfo>;
  deleteTeam(myTeamId:string, myRole:UserRole): Promise<void>;
  updateTeam(myTeamId:string, myRole:UserRole, teamName:string, teamPassword:string, teamRegion:number, openLevel:OpenLevel): Promise<void>;
  exitTeam(teamId:string): Promise<void>;
}

export class UserService {

  private static _instance: UserService

  private readonly _userRepository: IUserRepository;

  private constructor() {
    this._userRepository = UserRepository.instance;
  }

  static get instance() {
    if(!this._instance) {
      this._instance = new UserService();
    }
    return this._instance;
  }

  async info(userId:string) {
    return await this._userRepository.info(userId);
  }

  async update(userId:string, name: string, email: string): Promise<void> {
    await this._userRepository.updateInfo(userId, name, email);
  }

  async delete(userId:string) {
    await this._userRepository.delete(userId);
  }
  
  async joinNewTeam(userId:string, teamName: string, teamPassword: string, teamRegion:number, myTeamId:string) {
    if (!myTeamId) {
      return await this._userRepository.joinTeam(userId, teamName, teamRegion, teamPassword);
    } else {
      throw new Error('すでにチームに所属しています');
    }
  }
  
  async createTeam(userId:string, teamName:string, teamPassword:string, regionNum:number, myTeamId:string, openLevel: OpenLevel): Promise<TeamInfo> {
    if (!myTeamId) {
      return await this._userRepository.createTeam(userId, teamName, teamPassword, regionNum, openLevel);
    } else {
      console.log(11111)
      throw new Error('すでにチームに所属しています');
    }
  }

  async updateTeam(myTeamId:string, myRole:UserRole, teamName:string, teamPassword:string, teamRegion:number, openLevel: OpenLevel ) {
    if (myTeamId) {
      if(myRole === UserRole.owner) {
        await this._userRepository.updateTeam(myTeamId, teamName, teamPassword, teamRegion, openLevel);
      } else {
        throw new Error('編集権限はチームオーナーのみ持っています');
      }
    } else {
      throw new Error('所属チームがありません');
    }
  }

  async deleteTeam(userId:string, teamId:string, myRole:UserRole,) {
    if (teamId) {
      if(myRole === UserRole.owner) {
        await this._userRepository.deleteTeam(userId, teamId);
      } else {
        throw new Error('編集権限はチームオーナーのみ持っています');
      }
    } else {
      throw new Error('所属チームがありません');
    }
  }

  async exitTeam(userId:string, teamId:string) {
    if (teamId) {
      await this._userRepository.exitTeam(userId);
    } else {
      throw new Error('所属チームがありません');
    }
  }
}
